/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CreatorTokenRouteImport } from './routes/creator/$token'
import { Route as AppWebhooksRouteImport } from './routes/_app/webhooks'
import { Route as AppSocialListeningRouteImport } from './routes/_app/social-listening'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppPlaygroundPremiumRouteImport } from './routes/_app/playground-premium'
import { Route as AppPlaygroundRouteImport } from './routes/_app/playground'
import { Route as AppMembersRouteImport } from './routes/_app/members'
import { Route as AppIntegrationsRouteImport } from './routes/_app/integrations'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppCampaignsRouteImport } from './routes/_app/campaigns'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppWebhooksIndexRouteImport } from './routes/_app/webhooks/index'
import { Route as AppSocialListeningIndexRouteImport } from './routes/_app/social-listening/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppReferralsIndexRouteImport } from './routes/_app/referrals.index'
import { Route as AppCreatorsIndexRouteImport } from './routes/_app/creators/index'
import { Route as AppWebhooksOutboundRouteImport } from './routes/_app/webhooks/outbound'
import { Route as AppWebhooksIncomingRouteImport } from './routes/_app/webhooks/incoming'
import { Route as AppSocialListeningSettingsRouteImport } from './routes/_app/social-listening/settings'
import { Route as AppSettingsWebhooksRouteImport } from './routes/_app/settings/webhooks'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/settings/team'
import { Route as AppSettingsSocialListeningRouteImport } from './routes/_app/settings/social-listening'
import { Route as AppSettingsPlaygroundRouteImport } from './routes/_app/settings/playground'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsHistoryRouteImport } from './routes/_app/settings/history'
import { Route as AppSettingsGeneralRouteImport } from './routes/_app/settings/general'
import { Route as AppSettingsDevelopersRouteImport } from './routes/_app/settings/developers'
import { Route as AppSettingsCreatorsRouteImport } from './routes/_app/settings/creators'
import { Route as AppReferralsNetworkRouteImport } from './routes/_app/referrals/network'
import { Route as AppCreatorsModeracaoRouteImport } from './routes/_app/creators/moderacao'
import { Route as AppCreatorsAnalyticsRouteImport } from './routes/_app/creators/analytics'
import { Route as AppCreatorsIdRouteImport } from './routes/_app/creators/$id'
import { Route as AppBackofficeMerchantsRouteImport } from './routes/_app/backoffice/merchants'
import { Route as AppSettingsWebhooksIndexRouteImport } from './routes/_app/settings/webhooks/index'
import { Route as AppSettingsIntegrationsIndexRouteImport } from './routes/_app/settings/integrations/index'
import { Route as AppSettingsWebhooksOutboundRouteImport } from './routes/_app/settings/webhooks/outbound'
import { Route as AppSettingsWebhooksIncomingRouteImport } from './routes/_app/settings/webhooks/incoming'
import { Route as AppSettingsIntegrationsYampiRouteImport } from './routes/_app/settings/integrations/yampi'
import { Route as AppSettingsIntegrationsTinyRouteImport } from './routes/_app/settings/integrations/tiny'
import { Route as AppSettingsIntegrationsKlaviyoRouteImport } from './routes/_app/settings/integrations/klaviyo'
import { Route as AppSettingsIntegrationsGuruRouteImport } from './routes/_app/settings/integrations/guru'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorTokenRoute = CreatorTokenRouteImport.update({
  id: '/creator/$token',
  path: '/creator/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWebhooksRoute = AppWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppRoute,
} as any)
const AppSocialListeningRoute = AppSocialListeningRouteImport.update({
  id: '/social-listening',
  path: '/social-listening',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppPlaygroundPremiumRoute = AppPlaygroundPremiumRouteImport.update({
  id: '/playground-premium',
  path: '/playground-premium',
  getParentRoute: () => AppRoute,
} as any)
const AppPlaygroundRoute = AppPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersRoute = AppMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsRoute = AppCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppWebhooksIndexRoute = AppWebhooksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWebhooksRoute,
} as any)
const AppSocialListeningIndexRoute = AppSocialListeningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSocialListeningRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppReferralsIndexRoute = AppReferralsIndexRouteImport.update({
  id: '/referrals/',
  path: '/referrals/',
  getParentRoute: () => AppRoute,
} as any)
const AppCreatorsIndexRoute = AppCreatorsIndexRouteImport.update({
  id: '/creators/',
  path: '/creators/',
  getParentRoute: () => AppRoute,
} as any)
const AppWebhooksOutboundRoute = AppWebhooksOutboundRouteImport.update({
  id: '/outbound',
  path: '/outbound',
  getParentRoute: () => AppWebhooksRoute,
} as any)
const AppWebhooksIncomingRoute = AppWebhooksIncomingRouteImport.update({
  id: '/incoming',
  path: '/incoming',
  getParentRoute: () => AppWebhooksRoute,
} as any)
const AppSocialListeningSettingsRoute =
  AppSocialListeningSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppSocialListeningRoute,
  } as any)
const AppSettingsWebhooksRoute = AppSettingsWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSocialListeningRoute =
  AppSettingsSocialListeningRouteImport.update({
    id: '/social-listening',
    path: '/social-listening',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsPlaygroundRoute = AppSettingsPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsHistoryRoute = AppSettingsHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsGeneralRoute = AppSettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDevelopersRoute = AppSettingsDevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCreatorsRoute = AppSettingsCreatorsRouteImport.update({
  id: '/creators',
  path: '/creators',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppReferralsNetworkRoute = AppReferralsNetworkRouteImport.update({
  id: '/referrals/network',
  path: '/referrals/network',
  getParentRoute: () => AppRoute,
} as any)
const AppCreatorsModeracaoRoute = AppCreatorsModeracaoRouteImport.update({
  id: '/creators/moderacao',
  path: '/creators/moderacao',
  getParentRoute: () => AppRoute,
} as any)
const AppCreatorsAnalyticsRoute = AppCreatorsAnalyticsRouteImport.update({
  id: '/creators/analytics',
  path: '/creators/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppCreatorsIdRoute = AppCreatorsIdRouteImport.update({
  id: '/creators/$id',
  path: '/creators/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBackofficeMerchantsRoute = AppBackofficeMerchantsRouteImport.update({
  id: '/backoffice/merchants',
  path: '/backoffice/merchants',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWebhooksIndexRoute =
  AppSettingsWebhooksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsWebhooksRoute,
  } as any)
const AppSettingsIntegrationsIndexRoute =
  AppSettingsIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsWebhooksOutboundRoute =
  AppSettingsWebhooksOutboundRouteImport.update({
    id: '/outbound',
    path: '/outbound',
    getParentRoute: () => AppSettingsWebhooksRoute,
  } as any)
const AppSettingsWebhooksIncomingRoute =
  AppSettingsWebhooksIncomingRouteImport.update({
    id: '/incoming',
    path: '/incoming',
    getParentRoute: () => AppSettingsWebhooksRoute,
  } as any)
const AppSettingsIntegrationsYampiRoute =
  AppSettingsIntegrationsYampiRouteImport.update({
    id: '/integrations/yampi',
    path: '/integrations/yampi',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsIntegrationsTinyRoute =
  AppSettingsIntegrationsTinyRouteImport.update({
    id: '/integrations/tiny',
    path: '/integrations/tiny',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsIntegrationsKlaviyoRoute =
  AppSettingsIntegrationsKlaviyoRouteImport.update({
    id: '/integrations/klaviyo',
    path: '/integrations/klaviyo',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsIntegrationsGuruRoute =
  AppSettingsIntegrationsGuruRouteImport.update({
    id: '/integrations/guru',
    path: '/integrations/guru',
    getParentRoute: () => AppSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/campaigns': typeof AppCampaignsRoute
  '/dashboard': typeof AppDashboardRoute
  '/integrations': typeof AppIntegrationsRoute
  '/members': typeof AppMembersRoute
  '/playground': typeof AppPlaygroundRoute
  '/playground-premium': typeof AppPlaygroundPremiumRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/social-listening': typeof AppSocialListeningRouteWithChildren
  '/webhooks': typeof AppWebhooksRouteWithChildren
  '/creator/$token': typeof CreatorTokenRoute
  '/backoffice/merchants': typeof AppBackofficeMerchantsRoute
  '/creators/$id': typeof AppCreatorsIdRoute
  '/creators/analytics': typeof AppCreatorsAnalyticsRoute
  '/creators/moderacao': typeof AppCreatorsModeracaoRoute
  '/referrals/network': typeof AppReferralsNetworkRoute
  '/settings/creators': typeof AppSettingsCreatorsRoute
  '/settings/developers': typeof AppSettingsDevelopersRoute
  '/settings/general': typeof AppSettingsGeneralRoute
  '/settings/history': typeof AppSettingsHistoryRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/playground': typeof AppSettingsPlaygroundRoute
  '/settings/social-listening': typeof AppSettingsSocialListeningRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/webhooks': typeof AppSettingsWebhooksRouteWithChildren
  '/social-listening/settings': typeof AppSocialListeningSettingsRoute
  '/webhooks/incoming': typeof AppWebhooksIncomingRoute
  '/webhooks/outbound': typeof AppWebhooksOutboundRoute
  '/creators': typeof AppCreatorsIndexRoute
  '/referrals': typeof AppReferralsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/social-listening/': typeof AppSocialListeningIndexRoute
  '/webhooks/': typeof AppWebhooksIndexRoute
  '/settings/integrations/guru': typeof AppSettingsIntegrationsGuruRoute
  '/settings/integrations/klaviyo': typeof AppSettingsIntegrationsKlaviyoRoute
  '/settings/integrations/tiny': typeof AppSettingsIntegrationsTinyRoute
  '/settings/integrations/yampi': typeof AppSettingsIntegrationsYampiRoute
  '/settings/webhooks/incoming': typeof AppSettingsWebhooksIncomingRoute
  '/settings/webhooks/outbound': typeof AppSettingsWebhooksOutboundRoute
  '/settings/integrations': typeof AppSettingsIntegrationsIndexRoute
  '/settings/webhooks/': typeof AppSettingsWebhooksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/campaigns': typeof AppCampaignsRoute
  '/dashboard': typeof AppDashboardRoute
  '/integrations': typeof AppIntegrationsRoute
  '/members': typeof AppMembersRoute
  '/playground': typeof AppPlaygroundRoute
  '/playground-premium': typeof AppPlaygroundPremiumRoute
  '/creator/$token': typeof CreatorTokenRoute
  '/backoffice/merchants': typeof AppBackofficeMerchantsRoute
  '/creators/$id': typeof AppCreatorsIdRoute
  '/creators/analytics': typeof AppCreatorsAnalyticsRoute
  '/creators/moderacao': typeof AppCreatorsModeracaoRoute
  '/referrals/network': typeof AppReferralsNetworkRoute
  '/settings/creators': typeof AppSettingsCreatorsRoute
  '/settings/developers': typeof AppSettingsDevelopersRoute
  '/settings/general': typeof AppSettingsGeneralRoute
  '/settings/history': typeof AppSettingsHistoryRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/playground': typeof AppSettingsPlaygroundRoute
  '/settings/social-listening': typeof AppSettingsSocialListeningRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/social-listening/settings': typeof AppSocialListeningSettingsRoute
  '/webhooks/incoming': typeof AppWebhooksIncomingRoute
  '/webhooks/outbound': typeof AppWebhooksOutboundRoute
  '/creators': typeof AppCreatorsIndexRoute
  '/referrals': typeof AppReferralsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/social-listening': typeof AppSocialListeningIndexRoute
  '/webhooks': typeof AppWebhooksIndexRoute
  '/settings/integrations/guru': typeof AppSettingsIntegrationsGuruRoute
  '/settings/integrations/klaviyo': typeof AppSettingsIntegrationsKlaviyoRoute
  '/settings/integrations/tiny': typeof AppSettingsIntegrationsTinyRoute
  '/settings/integrations/yampi': typeof AppSettingsIntegrationsYampiRoute
  '/settings/webhooks/incoming': typeof AppSettingsWebhooksIncomingRoute
  '/settings/webhooks/outbound': typeof AppSettingsWebhooksOutboundRoute
  '/settings/integrations': typeof AppSettingsIntegrationsIndexRoute
  '/settings/webhooks': typeof AppSettingsWebhooksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/campaigns': typeof AppCampaignsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/members': typeof AppMembersRoute
  '/_app/playground': typeof AppPlaygroundRoute
  '/_app/playground-premium': typeof AppPlaygroundPremiumRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/social-listening': typeof AppSocialListeningRouteWithChildren
  '/_app/webhooks': typeof AppWebhooksRouteWithChildren
  '/creator/$token': typeof CreatorTokenRoute
  '/_app/backoffice/merchants': typeof AppBackofficeMerchantsRoute
  '/_app/creators/$id': typeof AppCreatorsIdRoute
  '/_app/creators/analytics': typeof AppCreatorsAnalyticsRoute
  '/_app/creators/moderacao': typeof AppCreatorsModeracaoRoute
  '/_app/referrals/network': typeof AppReferralsNetworkRoute
  '/_app/settings/creators': typeof AppSettingsCreatorsRoute
  '/_app/settings/developers': typeof AppSettingsDevelopersRoute
  '/_app/settings/general': typeof AppSettingsGeneralRoute
  '/_app/settings/history': typeof AppSettingsHistoryRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/playground': typeof AppSettingsPlaygroundRoute
  '/_app/settings/social-listening': typeof AppSettingsSocialListeningRoute
  '/_app/settings/team': typeof AppSettingsTeamRoute
  '/_app/settings/webhooks': typeof AppSettingsWebhooksRouteWithChildren
  '/_app/social-listening/settings': typeof AppSocialListeningSettingsRoute
  '/_app/webhooks/incoming': typeof AppWebhooksIncomingRoute
  '/_app/webhooks/outbound': typeof AppWebhooksOutboundRoute
  '/_app/creators/': typeof AppCreatorsIndexRoute
  '/_app/referrals/': typeof AppReferralsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/social-listening/': typeof AppSocialListeningIndexRoute
  '/_app/webhooks/': typeof AppWebhooksIndexRoute
  '/_app/settings/integrations/guru': typeof AppSettingsIntegrationsGuruRoute
  '/_app/settings/integrations/klaviyo': typeof AppSettingsIntegrationsKlaviyoRoute
  '/_app/settings/integrations/tiny': typeof AppSettingsIntegrationsTinyRoute
  '/_app/settings/integrations/yampi': typeof AppSettingsIntegrationsYampiRoute
  '/_app/settings/webhooks/incoming': typeof AppSettingsWebhooksIncomingRoute
  '/_app/settings/webhooks/outbound': typeof AppSettingsWebhooksOutboundRoute
  '/_app/settings/integrations/': typeof AppSettingsIntegrationsIndexRoute
  '/_app/settings/webhooks/': typeof AppSettingsWebhooksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/analytics'
    | '/campaigns'
    | '/dashboard'
    | '/integrations'
    | '/members'
    | '/playground'
    | '/playground-premium'
    | '/settings'
    | '/social-listening'
    | '/webhooks'
    | '/creator/$token'
    | '/backoffice/merchants'
    | '/creators/$id'
    | '/creators/analytics'
    | '/creators/moderacao'
    | '/referrals/network'
    | '/settings/creators'
    | '/settings/developers'
    | '/settings/general'
    | '/settings/history'
    | '/settings/notifications'
    | '/settings/playground'
    | '/settings/social-listening'
    | '/settings/team'
    | '/settings/webhooks'
    | '/social-listening/settings'
    | '/webhooks/incoming'
    | '/webhooks/outbound'
    | '/creators'
    | '/referrals'
    | '/settings/'
    | '/social-listening/'
    | '/webhooks/'
    | '/settings/integrations/guru'
    | '/settings/integrations/klaviyo'
    | '/settings/integrations/tiny'
    | '/settings/integrations/yampi'
    | '/settings/webhooks/incoming'
    | '/settings/webhooks/outbound'
    | '/settings/integrations'
    | '/settings/webhooks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/analytics'
    | '/campaigns'
    | '/dashboard'
    | '/integrations'
    | '/members'
    | '/playground'
    | '/playground-premium'
    | '/creator/$token'
    | '/backoffice/merchants'
    | '/creators/$id'
    | '/creators/analytics'
    | '/creators/moderacao'
    | '/referrals/network'
    | '/settings/creators'
    | '/settings/developers'
    | '/settings/general'
    | '/settings/history'
    | '/settings/notifications'
    | '/settings/playground'
    | '/settings/social-listening'
    | '/settings/team'
    | '/social-listening/settings'
    | '/webhooks/incoming'
    | '/webhooks/outbound'
    | '/creators'
    | '/referrals'
    | '/settings'
    | '/social-listening'
    | '/webhooks'
    | '/settings/integrations/guru'
    | '/settings/integrations/klaviyo'
    | '/settings/integrations/tiny'
    | '/settings/integrations/yampi'
    | '/settings/webhooks/incoming'
    | '/settings/webhooks/outbound'
    | '/settings/integrations'
    | '/settings/webhooks'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/_app/analytics'
    | '/_app/campaigns'
    | '/_app/dashboard'
    | '/_app/integrations'
    | '/_app/members'
    | '/_app/playground'
    | '/_app/playground-premium'
    | '/_app/settings'
    | '/_app/social-listening'
    | '/_app/webhooks'
    | '/creator/$token'
    | '/_app/backoffice/merchants'
    | '/_app/creators/$id'
    | '/_app/creators/analytics'
    | '/_app/creators/moderacao'
    | '/_app/referrals/network'
    | '/_app/settings/creators'
    | '/_app/settings/developers'
    | '/_app/settings/general'
    | '/_app/settings/history'
    | '/_app/settings/notifications'
    | '/_app/settings/playground'
    | '/_app/settings/social-listening'
    | '/_app/settings/team'
    | '/_app/settings/webhooks'
    | '/_app/social-listening/settings'
    | '/_app/webhooks/incoming'
    | '/_app/webhooks/outbound'
    | '/_app/creators/'
    | '/_app/referrals/'
    | '/_app/settings/'
    | '/_app/social-listening/'
    | '/_app/webhooks/'
    | '/_app/settings/integrations/guru'
    | '/_app/settings/integrations/klaviyo'
    | '/_app/settings/integrations/tiny'
    | '/_app/settings/integrations/yampi'
    | '/_app/settings/webhooks/incoming'
    | '/_app/settings/webhooks/outbound'
    | '/_app/settings/integrations/'
    | '/_app/settings/webhooks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TermsRoute: typeof TermsRoute
  CreatorTokenRoute: typeof CreatorTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator/$token': {
      id: '/creator/$token'
      path: '/creator/$token'
      fullPath: '/creator/$token'
      preLoaderRoute: typeof CreatorTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/webhooks': {
      id: '/_app/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof AppWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/social-listening': {
      id: '/_app/social-listening'
      path: '/social-listening'
      fullPath: '/social-listening'
      preLoaderRoute: typeof AppSocialListeningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/playground-premium': {
      id: '/_app/playground-premium'
      path: '/playground-premium'
      fullPath: '/playground-premium'
      preLoaderRoute: typeof AppPlaygroundPremiumRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/playground': {
      id: '/_app/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof AppPlaygroundRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members': {
      id: '/_app/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AppMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns': {
      id: '/_app/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AppCampaignsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/webhooks/': {
      id: '/_app/webhooks/'
      path: '/'
      fullPath: '/webhooks/'
      preLoaderRoute: typeof AppWebhooksIndexRouteImport
      parentRoute: typeof AppWebhooksRoute
    }
    '/_app/social-listening/': {
      id: '/_app/social-listening/'
      path: '/'
      fullPath: '/social-listening/'
      preLoaderRoute: typeof AppSocialListeningIndexRouteImport
      parentRoute: typeof AppSocialListeningRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/referrals/': {
      id: '/_app/referrals/'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AppReferralsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/creators/': {
      id: '/_app/creators/'
      path: '/creators'
      fullPath: '/creators'
      preLoaderRoute: typeof AppCreatorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/webhooks/outbound': {
      id: '/_app/webhooks/outbound'
      path: '/outbound'
      fullPath: '/webhooks/outbound'
      preLoaderRoute: typeof AppWebhooksOutboundRouteImport
      parentRoute: typeof AppWebhooksRoute
    }
    '/_app/webhooks/incoming': {
      id: '/_app/webhooks/incoming'
      path: '/incoming'
      fullPath: '/webhooks/incoming'
      preLoaderRoute: typeof AppWebhooksIncomingRouteImport
      parentRoute: typeof AppWebhooksRoute
    }
    '/_app/social-listening/settings': {
      id: '/_app/social-listening/settings'
      path: '/settings'
      fullPath: '/social-listening/settings'
      preLoaderRoute: typeof AppSocialListeningSettingsRouteImport
      parentRoute: typeof AppSocialListeningRoute
    }
    '/_app/settings/webhooks': {
      id: '/_app/settings/webhooks'
      path: '/webhooks'
      fullPath: '/settings/webhooks'
      preLoaderRoute: typeof AppSettingsWebhooksRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/team': {
      id: '/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/social-listening': {
      id: '/_app/settings/social-listening'
      path: '/social-listening'
      fullPath: '/settings/social-listening'
      preLoaderRoute: typeof AppSettingsSocialListeningRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/playground': {
      id: '/_app/settings/playground'
      path: '/playground'
      fullPath: '/settings/playground'
      preLoaderRoute: typeof AppSettingsPlaygroundRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/history': {
      id: '/_app/settings/history'
      path: '/history'
      fullPath: '/settings/history'
      preLoaderRoute: typeof AppSettingsHistoryRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/general': {
      id: '/_app/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AppSettingsGeneralRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/developers': {
      id: '/_app/settings/developers'
      path: '/developers'
      fullPath: '/settings/developers'
      preLoaderRoute: typeof AppSettingsDevelopersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/creators': {
      id: '/_app/settings/creators'
      path: '/creators'
      fullPath: '/settings/creators'
      preLoaderRoute: typeof AppSettingsCreatorsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/referrals/network': {
      id: '/_app/referrals/network'
      path: '/referrals/network'
      fullPath: '/referrals/network'
      preLoaderRoute: typeof AppReferralsNetworkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/creators/moderacao': {
      id: '/_app/creators/moderacao'
      path: '/creators/moderacao'
      fullPath: '/creators/moderacao'
      preLoaderRoute: typeof AppCreatorsModeracaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/creators/analytics': {
      id: '/_app/creators/analytics'
      path: '/creators/analytics'
      fullPath: '/creators/analytics'
      preLoaderRoute: typeof AppCreatorsAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/creators/$id': {
      id: '/_app/creators/$id'
      path: '/creators/$id'
      fullPath: '/creators/$id'
      preLoaderRoute: typeof AppCreatorsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/backoffice/merchants': {
      id: '/_app/backoffice/merchants'
      path: '/backoffice/merchants'
      fullPath: '/backoffice/merchants'
      preLoaderRoute: typeof AppBackofficeMerchantsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/webhooks/': {
      id: '/_app/settings/webhooks/'
      path: '/'
      fullPath: '/settings/webhooks/'
      preLoaderRoute: typeof AppSettingsWebhooksIndexRouteImport
      parentRoute: typeof AppSettingsWebhooksRoute
    }
    '/_app/settings/integrations/': {
      id: '/_app/settings/integrations/'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/webhooks/outbound': {
      id: '/_app/settings/webhooks/outbound'
      path: '/outbound'
      fullPath: '/settings/webhooks/outbound'
      preLoaderRoute: typeof AppSettingsWebhooksOutboundRouteImport
      parentRoute: typeof AppSettingsWebhooksRoute
    }
    '/_app/settings/webhooks/incoming': {
      id: '/_app/settings/webhooks/incoming'
      path: '/incoming'
      fullPath: '/settings/webhooks/incoming'
      preLoaderRoute: typeof AppSettingsWebhooksIncomingRouteImport
      parentRoute: typeof AppSettingsWebhooksRoute
    }
    '/_app/settings/integrations/yampi': {
      id: '/_app/settings/integrations/yampi'
      path: '/integrations/yampi'
      fullPath: '/settings/integrations/yampi'
      preLoaderRoute: typeof AppSettingsIntegrationsYampiRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations/tiny': {
      id: '/_app/settings/integrations/tiny'
      path: '/integrations/tiny'
      fullPath: '/settings/integrations/tiny'
      preLoaderRoute: typeof AppSettingsIntegrationsTinyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations/klaviyo': {
      id: '/_app/settings/integrations/klaviyo'
      path: '/integrations/klaviyo'
      fullPath: '/settings/integrations/klaviyo'
      preLoaderRoute: typeof AppSettingsIntegrationsKlaviyoRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations/guru': {
      id: '/_app/settings/integrations/guru'
      path: '/integrations/guru'
      fullPath: '/settings/integrations/guru'
      preLoaderRoute: typeof AppSettingsIntegrationsGuruRouteImport
      parentRoute: typeof AppSettingsRoute
    }
  }
}

interface AppSettingsWebhooksRouteChildren {
  AppSettingsWebhooksIncomingRoute: typeof AppSettingsWebhooksIncomingRoute
  AppSettingsWebhooksOutboundRoute: typeof AppSettingsWebhooksOutboundRoute
  AppSettingsWebhooksIndexRoute: typeof AppSettingsWebhooksIndexRoute
}

const AppSettingsWebhooksRouteChildren: AppSettingsWebhooksRouteChildren = {
  AppSettingsWebhooksIncomingRoute: AppSettingsWebhooksIncomingRoute,
  AppSettingsWebhooksOutboundRoute: AppSettingsWebhooksOutboundRoute,
  AppSettingsWebhooksIndexRoute: AppSettingsWebhooksIndexRoute,
}

const AppSettingsWebhooksRouteWithChildren =
  AppSettingsWebhooksRoute._addFileChildren(AppSettingsWebhooksRouteChildren)

interface AppSettingsRouteChildren {
  AppSettingsCreatorsRoute: typeof AppSettingsCreatorsRoute
  AppSettingsDevelopersRoute: typeof AppSettingsDevelopersRoute
  AppSettingsGeneralRoute: typeof AppSettingsGeneralRoute
  AppSettingsHistoryRoute: typeof AppSettingsHistoryRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsPlaygroundRoute: typeof AppSettingsPlaygroundRoute
  AppSettingsSocialListeningRoute: typeof AppSettingsSocialListeningRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsWebhooksRoute: typeof AppSettingsWebhooksRouteWithChildren
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsIntegrationsGuruRoute: typeof AppSettingsIntegrationsGuruRoute
  AppSettingsIntegrationsKlaviyoRoute: typeof AppSettingsIntegrationsKlaviyoRoute
  AppSettingsIntegrationsTinyRoute: typeof AppSettingsIntegrationsTinyRoute
  AppSettingsIntegrationsYampiRoute: typeof AppSettingsIntegrationsYampiRoute
  AppSettingsIntegrationsIndexRoute: typeof AppSettingsIntegrationsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsCreatorsRoute: AppSettingsCreatorsRoute,
  AppSettingsDevelopersRoute: AppSettingsDevelopersRoute,
  AppSettingsGeneralRoute: AppSettingsGeneralRoute,
  AppSettingsHistoryRoute: AppSettingsHistoryRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsPlaygroundRoute: AppSettingsPlaygroundRoute,
  AppSettingsSocialListeningRoute: AppSettingsSocialListeningRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsWebhooksRoute: AppSettingsWebhooksRouteWithChildren,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsIntegrationsGuruRoute: AppSettingsIntegrationsGuruRoute,
  AppSettingsIntegrationsKlaviyoRoute: AppSettingsIntegrationsKlaviyoRoute,
  AppSettingsIntegrationsTinyRoute: AppSettingsIntegrationsTinyRoute,
  AppSettingsIntegrationsYampiRoute: AppSettingsIntegrationsYampiRoute,
  AppSettingsIntegrationsIndexRoute: AppSettingsIntegrationsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppSocialListeningRouteChildren {
  AppSocialListeningSettingsRoute: typeof AppSocialListeningSettingsRoute
  AppSocialListeningIndexRoute: typeof AppSocialListeningIndexRoute
}

const AppSocialListeningRouteChildren: AppSocialListeningRouteChildren = {
  AppSocialListeningSettingsRoute: AppSocialListeningSettingsRoute,
  AppSocialListeningIndexRoute: AppSocialListeningIndexRoute,
}

const AppSocialListeningRouteWithChildren =
  AppSocialListeningRoute._addFileChildren(AppSocialListeningRouteChildren)

interface AppWebhooksRouteChildren {
  AppWebhooksIncomingRoute: typeof AppWebhooksIncomingRoute
  AppWebhooksOutboundRoute: typeof AppWebhooksOutboundRoute
  AppWebhooksIndexRoute: typeof AppWebhooksIndexRoute
}

const AppWebhooksRouteChildren: AppWebhooksRouteChildren = {
  AppWebhooksIncomingRoute: AppWebhooksIncomingRoute,
  AppWebhooksOutboundRoute: AppWebhooksOutboundRoute,
  AppWebhooksIndexRoute: AppWebhooksIndexRoute,
}

const AppWebhooksRouteWithChildren = AppWebhooksRoute._addFileChildren(
  AppWebhooksRouteChildren,
)

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppCampaignsRoute: typeof AppCampaignsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppMembersRoute: typeof AppMembersRoute
  AppPlaygroundRoute: typeof AppPlaygroundRoute
  AppPlaygroundPremiumRoute: typeof AppPlaygroundPremiumRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppSocialListeningRoute: typeof AppSocialListeningRouteWithChildren
  AppWebhooksRoute: typeof AppWebhooksRouteWithChildren
  AppBackofficeMerchantsRoute: typeof AppBackofficeMerchantsRoute
  AppCreatorsIdRoute: typeof AppCreatorsIdRoute
  AppCreatorsAnalyticsRoute: typeof AppCreatorsAnalyticsRoute
  AppCreatorsModeracaoRoute: typeof AppCreatorsModeracaoRoute
  AppReferralsNetworkRoute: typeof AppReferralsNetworkRoute
  AppCreatorsIndexRoute: typeof AppCreatorsIndexRoute
  AppReferralsIndexRoute: typeof AppReferralsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppCampaignsRoute: AppCampaignsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppMembersRoute: AppMembersRoute,
  AppPlaygroundRoute: AppPlaygroundRoute,
  AppPlaygroundPremiumRoute: AppPlaygroundPremiumRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppSocialListeningRoute: AppSocialListeningRouteWithChildren,
  AppWebhooksRoute: AppWebhooksRouteWithChildren,
  AppBackofficeMerchantsRoute: AppBackofficeMerchantsRoute,
  AppCreatorsIdRoute: AppCreatorsIdRoute,
  AppCreatorsAnalyticsRoute: AppCreatorsAnalyticsRoute,
  AppCreatorsModeracaoRoute: AppCreatorsModeracaoRoute,
  AppReferralsNetworkRoute: AppReferralsNetworkRoute,
  AppCreatorsIndexRoute: AppCreatorsIndexRoute,
  AppReferralsIndexRoute: AppReferralsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TermsRoute: TermsRoute,
  CreatorTokenRoute: CreatorTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
